







































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Typography from '@/components/common/elements/Typography.vue';

@Component({
  components:{ SingleText, Typography}
})
export default class Dialog extends Vue {
  // ダイアログ開閉状態
  @Prop({ default: false })
  private dialog?: boolean;
  // ダイアログ内表示タイトル
  @Prop({ default: '' })
  private title!: string;
  // ダイアログ内表示テキスト
  @Prop({ default: '' })
  private bodyText!: string;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  @Prop({ default: true })
  private isPersistent?: boolean;
  // ダイアログ内ボタンをテキストに変更
  @Prop({ default: false })
  private isTextActionButtom?: boolean; 
  // ダイアログ内NGボタン文字
  @Prop({ default: 'キャンセル' })
  private buttomTextNG?: string;
  // ダイアログ内OKボタン文字
  @Prop({ default: 'OK' })
  private buttomTextOK?: string;
  // ダイアログ内NGボタン文字色
  @Prop({ default: 'light' })
  private buttomColorNG?: string;
  // ダイアログ内OKボタン文字色
  @Prop({ default: 'primary' })
  private buttomColorOK?: string;
  @Prop({ default: true })
  private isShowNG?: boolean;
  @Prop({ default: false })
  private isBodyTextCenter?: boolean;

  /**
   * 親コンポーネントに押下したか否か通知する
   * @module addDetailsOpratipon
   * @return {AddDetailResponse} - 要素ステータス、押下判定
   */
  @Emit('confirmOpratipon')
  public confirmOpratipon(isAgree: boolean): { [k:string]: boolean} {
    return {dialog: false, isAgree: isAgree};
  }
}
